module.exports = __webpack_public_path__ + "img/price.6da86810.svg";